import { Link } from '@hc/redux-saga-router-plus';
import { TextButton } from 'legacy/components/Button';

import { UserDefinedLocationMarkerPopup as theme } from 'legacy/css-modules';

const UserDefinedLocationMarkerPopup = ({ buttonView, hideButton }) => {
  return (
    <div className={theme.UserDefinedLocationMarkerPopup}>
      <h4 className={theme.Title}>User Defined</h4>
      {hideButton ? (
        <div className={theme.Spacer} />
      ) : (
        <Link view={buttonView} options={{ inherit: true }}>
          <TextButton className={theme.Button}>Update</TextButton>
        </Link>
      )}
      <div className={theme.Caret} />
    </div>
  );
};

export default UserDefinedLocationMarkerPopup;
